export default "__VITE_ASSET__DMWSufi3__"